<template>
  <div>
    <div v-if="datosSesion.idPerfil===6">
      <MenuDocente/>
    </div>
    <div v-else-if="datosSesion.idPerfil===7">
      <MenuEstudiante/>
    </div>
    <div v-else>
      <MenuPrincipal/>
    </div>
    <router-view/>
    <PiePagina/>
  </div>
</template>

<script>
  import {mapState} from 'vuex'
  import MenuPrincipal from '@/components/menus/MenuPrincipal'
  import MenuDocente from '@/components/menus/MenuDocente'
  import MenuEstudiante from '@/components/menus/MenuEstudiante'
  import PiePagina from '@/components/pies/PiePagina'

  export default {
    name: 'Index',
    components: {
      MenuPrincipal,
      MenuDocente,
      MenuEstudiante,
      PiePagina
    },
    methods: {
      iniciarFormulario(){
        if (this.datosSesion.idColegio == 0) {
          sessionStorage.removeItem('token')
          this.$router.push("/Error")
        }
      }
    },
    beforeMount() {
      this.iniciarFormulario()
    },
    computed: {
      ...mapState(['datosSesion'])
    }
  }
</script>
